angular.module('stack.common.i18n.resolvers.TranslationResolver', [
  'stack.common.i18n.models.TranslationModel'
])

/**
 * The TranslatorResolver service loads a map of strings based
 * upon the locale reported by the browser.
 *
 * @class TranslationResolver
 * @constructor
 * @module stack.common.i18n.resolvers.TranslationResolver
 */
.factory('TranslationResolver', [
  'TranslationModel',
  function (TranslationModel) {
    'use strict';

    return function () {
      // Load translation map.
      return TranslationModel.get();
    };
  }
]);
